import { put } from 'redux-saga/effects'
import { createLabelAction } from '../../handles'
import { create, CreateLabelResponse } from '../_http/label'

export function* createLabelSaga(action: ReturnType<typeof createLabelAction.request>) {
  const label = action.payload
  try {
    const { label: newLabel }: CreateLabelResponse = yield create(label)
    yield put(createLabelAction.success(newLabel))
  } catch (error) {
    yield put(createLabelAction.failure())
  }
}
